import { apiService } from './api.service';
import type { ApiResponse } from '../types/api.types';
import type { Coach } from '../types/entities';
import { logger } from '../utils/logger';
import { API_ENDPOINTS } from '../config/api.config';

export const CoachService = {
    getAllCoaches: async (): Promise<Coach[]> => {
        try {
            const { data: responseData } = await apiService.get<ApiResponse<Coach[]>>(
                API_ENDPOINTS.COACHES.BASE
            );            
            return responseData.data;
        } catch (error) {
            logger.error('Error fetching coaches:', error);
            throw error;
        }
    },

    getCoachById: async (id: number): Promise<Coach> => {
        try {
            const { data: responseData } = await apiService.get<ApiResponse<Coach>>(
                API_ENDPOINTS.COACHES.GET(id)
            );
            return responseData.data;
        } catch (error) {
            logger.error(`Error fetching coach with id ${id}:`, error);
            throw error;
        }
    },

    createCoach: async (coachData: Partial<Coach>): Promise<Coach> => {
        try {
            const { data: responseData } = await apiService.post<ApiResponse<Coach>>(
                API_ENDPOINTS.COACHES.CREATE,
                coachData
            );
            return responseData.data;
        } catch (error) {
            logger.error('Error creating coach:', error);
            throw error;
        }
    },

    updateCoach: async (id: number, coachData: Partial<Coach>): Promise<Coach> => {
        try {
            const { data: responseData } = await apiService.put<ApiResponse<Coach>>(
                API_ENDPOINTS.COACHES.UPDATE(id),
                coachData
            );
            return responseData.data;
        } catch (error) {
            logger.error(`Error updating coach with id ${id}:`, error);
            throw error;
        }
    },

    blockCoach: async (id: number): Promise<void> => {
        try {
            await apiService.put(
                API_ENDPOINTS.COACHES.BLOCK(id)
            );
        } catch (error) {
            logger.error(`Error blocking coach with id ${id}:`, error);
            throw error;
        }
    },

    unblockCoach: async (id: number): Promise<void> => {
        try {
            await apiService.put(
                API_ENDPOINTS.COACHES.UNBLOCK(id)
            );
        } catch (error) {
            logger.error(`Error unblocking coach with id ${id}:`, error);
            throw error;
        }
    }
};

// Add default export
export default CoachService;
